import React, { FC, ReactNode } from 'react';

import { Money as MoneyModel } from 'api-client';
import rubBlack from 'assets/images/svg/rub-black.svg';
import { Money } from 'components/common/utils';

import { Image } from '../../../../../../components';
import styles from '../AccountDetails.module.scss';

type Props = {
  money: MoneyModel;
  label: string;
  actions: ReactNode;
};

export const AccountHeaderCard: FC<Props> = ({ money, label, actions }) => (
  <div className={styles.headerCard}>
    <div className={styles.headerBackground} />
    <div className={styles.headerContent}>
      <div className={styles.balanceSection}>
        <div className={styles.balanceIconWrapper}>
          <Image src={rubBlack} alt="ruble" />
        </div>
        <div className={styles.balanceInfo}>
          <div className={styles.balanceValue}>
            <Money money={money} />
          </div>
          <div className={styles.balanceLabel}>{label}</div>
        </div>
      </div>
      <div className={styles.actionsSection}>{actions}</div>
    </div>
  </div>
);
